import { z } from 'zod';
import { uuidSchema } from './common.schema.js';

// ─── Legal basis enum ─────────────────────────────────────────────────────────

export const ErasureLegalBasisSchema = z.enum([
  'ART17_REQUEST',           // Subject exercised right to erasure
  'ART17_3C_LEGAL_CLAIM',   // Legal obligation overrides: Art. 17(3)(c) legal claims
  'RETENTION_EXPIRED',       // Retention period lapsed
]);
export type ErasureLegalBasis = z.infer<typeof ErasureLegalBasisSchema>;

// ─── Request schemas ──────────────────────────────────────────────────────────

export const ErasePatientRequestSchema = z.object({
  legal_basis: ErasureLegalBasisSchema.default('ART17_REQUEST').describe(
    'Legal basis for the erasure request under GDPR Art. 17',
  ),
});
export type ErasePatientRequest = z.infer<typeof ErasePatientRequestSchema>;

export const EraseMilkProviderRequestSchema = z.object({
  legal_basis: ErasureLegalBasisSchema.default('ART17_REQUEST').describe(
    'Legal basis for the erasure request under GDPR Art. 17',
  ),
});
export type EraseMilkProviderRequest = z.infer<typeof EraseMilkProviderRequestSchema>;

// ─── Response schema ──────────────────────────────────────────────────────────

export const EraseResponseSchema = z.object({
  erased_id:            uuidSchema.describe('ID of the erased subject (patient_id or person_id)'),
  subject_type:         z.enum(['PATIENT', 'MILK_PROVIDER']),
  erased_at:            z.string().datetime().describe('ISO timestamp when erasure was completed'),
  erasure_legal_basis:  ErasureLegalBasisSchema,
  phi_enc_key_version:  z.string().describe('Key version used to encrypt the PHI tombstone'),
  related_records_deactivated: z.object({
    mother_infant_links:       z.number().int(),
    patient_donor_preferences: z.number().int(),
    patient_allergies:         z.number().int().optional(),
    patient_current_medications: z.number().int().optional(),
    patient_assignments:       z.number().int().optional(),
    patient_communications:    z.number().int().optional(),
    patient_medical_history:   z.number().int().optional(),
    health_records:            z.number().int().optional(),
    health_record_attachments: z.number().int().optional(),
  }).describe('Count of related rows deactivated during erasure'),
});
export type EraseResponse = z.infer<typeof EraseResponseSchema>;
